import { useEffect, useState } from "react";
import { api } from "../../../helpers/api";
import { ShowToast } from "../../../components/toast";
import { Button } from "../../../components/Button";
import { PopupModal } from "../../../components/PopupModal";
import { TextInput } from "../../../components/TextInput";
import { ReactComponent as CloseIcon } from "../../../assets/icons/x.svg";

export function ServiceForm({
  onClose,
  service,
  refetch,
}: {
  onClose: () => void;
  refetch: () => void;
  service?: any;
}) {
  const [formData, setFormData] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = () => {
    setIsLoading(true);
    const API = service?.id ? api.updateService : api.createService;
    API(formData)
      .then(() => {
        handleClose();
        refetch && refetch();
      })
      .catch(() => setIsLoading(false));
  };
  useEffect(() => {
    if (service) {
      setFormData(service);
    }
  }, [service]);
  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleClose = () => {
    setFormData({});
    onClose();
  };

  return (
    <PopupModal
      onClose={onClose}
      contentClassName="w-[500px] mx-auto relative"
      containerClassName="!z-[100]"
      shouldStopPropagation
    >
      <button
        onClick={onClose}
        className="absolute top-2 -right-6 [&_path]:stroke-white"
      >
        <CloseIcon />
      </button>
      <div className="text-black text-lg font-normal poppins">
        {service?.id ? "Edit" : "Add"} a service type
      </div>
      <div className="mb-4 flex flex-col gap-1.5">
        <label htmlFor="email" className="text-sm text-black/80">
          Service name
        </label>
        <TextInput
          type="text"
          name="name"
          placeholder="Enter service name"
          onChange={handleChange}
          value={formData.name || ""}
        />
      </div>
      <div className="flex flex-row gap-4 ml-auto">
        <Button
          className="px-8 text-[1rem]"
          onClick={handleSubmit}
          loading={isLoading}
          disabled={!formData.name}
          variant="primary"
        >
          Submit
        </Button>
      </div>
    </PopupModal>
  );
}

export function ConfirmDelete({
  onClose,
  userId,
  refetch,
  name,
}: {
  onClose: () => void;
  userId: string;
  refetch: () => void;
  name: string;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const handleDelete = () => {
    setIsLoading(true);
    api
      .deleteService(userId)
      .then(() => {
        onClose();
        ShowToast({
          message: "Service type deleted successfully",
          type: "success",
        });
        refetch && refetch();
        setIsLoading(false);
      })
      .catch(() => {
        ShowToast({
          message: "Failed to delete service type",
          type: "error",
        });
        setIsLoading(false);
      });
  };

  return (
    <PopupModal
      onClose={onClose}
      contentClassName="w-[500px] mx-auto"
      containerClassName="!z-[100]"
    >
      <p className="text-lg leading-[28.8px] poppins">
        Are you sure you want to delete {name} service type?
      </p>
      <div className="flex flex-row gap-4 ml-auto">
        <Button variant="outline" className="px-8" onClick={onClose}>
          No, go back
        </Button>
        <Button
          className="px-8 text-[1rem] !bg-[#FDCDCD] !text-[#D30000]"
          onClick={handleDelete}
          loading={isLoading}
          variant="primary"
        >
          Yes delete
        </Button>
      </div>
    </PopupModal>
  );
}
